module.exports = __webpack_public_path__ + "img/bcb19131e369120b2b4a809aab430d63.svg";